import type { InfiniteData, UseInfiniteQueryOptions } from '@tanstack/react-query';

import { alarmsListHistoricalAlarmActivations } from '@repo/sdk/funcs/alarmsListHistoricalAlarmActivations';
import { ListHistoricalAlarmActivationsResponseBody } from '@repo/sdk/models/components';
import { SDKError } from '@repo/sdk/models/errors';
import { ListHistoricalAlarmActivationsRequest } from '@repo/sdk/models/operations';

import { GaiaClientFunction } from '@/client/types';
import { GaiaQueryWithAgentId } from '@/queries/types';

export interface ListHistoricalAlarmActivationsInfiniteQueryProps extends GaiaQueryWithAgentId {
  initialPageParam?: string;
  client: GaiaClientFunction;
}

export const listHistoricalAlarmActivationsInfiniteQuery = ({
  agentId,
  initialPageParam = '',
  client,
}: ListHistoricalAlarmActivationsInfiniteQueryProps): UseInfiniteQueryOptions<
  ListHistoricalAlarmActivationsResponseBody,
  SDKError,
  InfiniteData<ListHistoricalAlarmActivationsResponseBody, string>,
  (string | undefined)[],
  string
> => {
  return {
    queryKey: [agentId, 'listHistoricalAlarmActivationsInfinite'],
    enabled: !!agentId,
    queryFn: ({
      pageParam,
    }: {
      pageParam: string;
    }): Promise<ListHistoricalAlarmActivationsResponseBody> => {
      return client<
        ListHistoricalAlarmActivationsRequest,
        ListHistoricalAlarmActivationsResponseBody
      >({
        gaiaFunc: alarmsListHistoricalAlarmActivations,
        request: {
          agentId: agentId!,
          cursor: pageParam || initialPageParam,
        },
      });
    },
    initialPageParam: initialPageParam,
    getNextPageParam: (
      lastPage: ListHistoricalAlarmActivationsResponseBody
    ): string | undefined => {
      return lastPage.nextCursor;
    },
  };
};
